<script lang="ts" setup>
import AppButton from "@/components/atoms/button/AppButton.vue";

const mypageRoute = {
  name: "Mypage"
};
</script>

<template>
  <div class="w-100 h-100 pb-4 mx-auto bg-white">
    <div class="d-flex justify-content-center">
      <img
        src="@/assets/svg/CantUseFeature/header.svg?webp&width=500"
        class="svg-image"
      />
    </div>
    <div class="p-3">
      <div class="cant-use-feature-content mb-4">
        <div class="d-flex justify-content-center">
          <img src="@/assets/svg/CantUseFeature/point.svg" />
        </div>
        <div>
          <div class="mt-4 mb-1">
            お仕事が見つかった時、すぐ応募できるようにアカウント登録を行いましょう！
          </div>
          <div class="d-flex justify-content-center">
            <SvgFlow />
          </div>
          <div class="d-flex justify-content-center">
            <img
              src="@/assets/svg/CantUseFeature/flow.svg?webp&width=500"
              class="svg-image"
            />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <AppButton :to="mypageRoute" class="w-100">
          アカウント登録に進む
        </AppButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cant-use-feature-content {
  padding: 14px 16px;
  border-radius: 8px;
  box-shadow: 0 0 6px rgba($black, 15%);
}

.svg-image {
  width: 100%;
  max-width: 500px;
}
</style>
